/** Stader StakePoolsManager — `getExchangeRate()` returns the
 *  1e18-scaled ETH-per-ETHx rate. (The 3-tuple variant
 *  `(totalEthBalance, totalEthxSupply, reportingBlock)` lives on
 *  StaderOracle, not StakePoolsManager — don't confuse the two.) */
export const StaderEthxAbi = [
  {
    name: 'getExchangeRate',
    type: 'function',
    stateMutability: 'view',
    inputs: [],
    outputs: [{ type: 'uint256' }],
  },
] as const

/** Stader MaticX (Ethereum home contract) — `convertMaticXToMatic`
 *  returns a 3-tuple `(amountInMatic, totalShares, totalPooledMatic)`.
 *  Pass `1e18` to get the 1e18-scaled MATIC-per-MaticX rate in the
 *  first element. */
export const StaderMaticXAbi = [
  {
    name: 'convertMaticXToMatic',
    type: 'function',
    stateMutability: 'view',
    inputs: [{ type: 'uint256', name: 'balance' }],
    outputs: [{ type: 'uint256' }, { type: 'uint256' }, { type: 'uint256' }],
  },
] as const
